import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'danger';
export const STATUS_INFO = 'info';

class Alert extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      type: props.type,
      style: {
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100%',
        height: '60px',
        padding: '20px',
        textAlign: 'center',
        backgroundColor: '#8cbf36',
        color: '#ffffff',
        zIndex: '100000',
        display: 'block'
      }
    };
  }

  componentDidMount() {

    switch (this.props.type) {
      case STATUS_SUCCESS:
        this.setState({style: {...this.state.style, ...{backgroundColor: '#8cbf36', color: '#ffffff',}}});
        break;
      case STATUS_ERROR:
        this.setState({style: {...this.state.style, ...{backgroundColor: '#ea3d36', color: '#ffffff',}}});
        break;
      case STATUS_INFO:
      default:
        this.setState({style: {...this.state.style, ...{backgroundColor: '#5bc0de', color: '#ffffff',}}});
        break;
    }
  }

  render() {
    return <div style={this.state.style}>{this.props.message}</div>
  };
}

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default Alert;
